<div class="add-visual-modal">
    <aside class="add-visual-modal__menu">
        <app-sidemenu [nodes]="menuItems" [selectedNodeId]="selectedMenuId" (nodeSelect)="onMenuSelected($event)">
        </app-sidemenu>
    </aside>

    <section class="add-visual-modal__content">
        <div [hidden]="selectedMenuId !== 'ask'" class="add-visual-modal__pane">
            <app-ask-panel
                title="What visual would you like to add?"
                description="Use plain language. You can review the result in Visual Editor."
                placeholder="Add a bar chart showing application count by PADU status"
                helperText="ASK will create the visual title and select the best chart type."
                [(value)]="askPromptValue">
            </app-ask-panel>
        </div>

        <div [hidden]="selectedMenuId !== 'visual-editor'" class="add-visual-modal__pane">
            <div class="add-visual-form">
                <p class="add-visual-form__title">{{ modalTitle }}</p>
                <p class="add-visual-form__description">Configure data, width and formatting for this visual.</p>

                <div class="add-visual-form__fields">
                    <div class="add-visual-form__field">
                        <label class="add-visual-form__field-label">Visual title <span class="add-visual-form__required">*</span></label>
                        <input type="text" class="add-visual-form__input" placeholder="e.g. Applications by PADU"
                            [(ngModel)]="draft.title" />
                    </div>

                    <div class="add-visual-form__field">
                        <label class="add-visual-form__field-label">Width (1-12)</label>
                        <input type="number" min="1" max="12" class="add-visual-form__input" [(ngModel)]="draft.width" />
                    </div>
                </div>
            </div>
        </div>

        <div [hidden]="selectedMenuId !== 'json-editor'" class="add-visual-modal__pane">
            <app-json-editor [initialJson]="jsonEditorInitialJson" jsonType="other"
                (jsonTextChange)="onJsonTextChange($event)">
            </app-json-editor>
        </div>

        <div [hidden]="selectedMenuId !== 'sql-query'" class="add-visual-modal__pane add-visual-modal__pane--full">
            <app-visual-code [currentQuery]="sqlQueryCode" [constructedQuery]="sqlQueryCode"></app-visual-code>
        </div>
    </section>
</div>
